import { takeEvery, call } from 'redux-saga/effects';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';
import { LOGIN } from './auth';
import { FETCH_ME } from './me';

export const MARK_AS_SEEN = 'notifications/MARK_AS_SEEN';

export default function reducer(state = {}, action) {
    switch (action.type) {
        case MARK_AS_SEEN:
            return {
                ...state,
                [action.notification]: true,
            };
        case actionKey.success(FETCH_ME):
        case actionKey.success(LOGIN):
            if (action.payload.notifications) {
                return action.payload.notifications.reduce((acc, key) => {
                    acc[key] = true;
                    return acc;
                }, {
                    ...state,
                });
            }
            return state;
        default:
            return state;
    }
}

export const markAsSeenAction = (notification, save = true) => ({
    type: MARK_AS_SEEN,
    notification,
    save,
});

export function* rootSaga() {
    yield takeEvery(MARK_AS_SEEN, markAsSeen);
}

export function* markAsSeen({ type, notification, save }) {
    if (!save) {
        return;
    }
    yield call(request, {
        url: '/api/me/notification',
        type,
        options: {
            method: 'POST',
            body: {
                notification,
            },
        },
    });
}



// WEBPACK FOOTER //
// ./src/client/redux/notifications.js